import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../context/SnackBarContext";
import fetcher from "../../../helper/fetcher";


export default function ResetPasswordConfirmQr({ email, onNext }) {
  const [user, setUser] = useState({ password: "", confirmPassword: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const navigate = useNavigate();
  const { showSuccess, showError } = useSnackbar();

  const updateState = (newState) => {
    setUser((prev) => ({ ...prev, ...newState }));
    if (newState.password !== undefined) evaluateStrength(newState.password);
  };

  const evaluateStrength = (password) => {
    if (password.length >= 12) setPasswordStrength("Excellent");
    else if (password.length >= 8) setPasswordStrength("Good");
    else setPasswordStrength("Weak");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user.password || !user.confirmPassword) {
      showError("Please fill all fields");
      return;
    }
    if (user.password !== user.confirmPassword) {
      showError("Passwords do not match");
      return;
    }

    fetcher
      .post("/qr/auth/reset_password", {
        email,
        newPassword: user.password, 
      })

      .then((res) => {
        if (res.data.success) {
          showSuccess(res.data.message || "Password reset successfully!");
          onNext();
        } else {
          showError(res.data.message || "Failed to reset password");
        }
      })
      .catch((err) => {
        showError(err.response?.data?.message || "Server error");
      })
      .finally(() => {
        console.log("Password reset request finished");
      });
  };

  return (
    <div className="flex items-center justify-center bg-[#f4f5f7]">
      <div className="bg-white w-full">
        <div className="flex justify-center mb-6">
          <RiLockPasswordLine className="h-20 w-20 text-[#bf98ce]" />
        </div>

        <h2 className="text-2xl font-bold text-center mb-2">Reset password</h2>
        <p className="text-center text-gray-500 mb-6">
          Please kindly set your new password
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4 relative">
            <label className="block text-black font-semibold uppercase">
              New password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="at least 8 characters"
              className="w-full p-2 border border-gray-300 rounded mt-2 pr-10"
              value={user.password}
              name="password"
              onChange={(e) => updateState({ password: e.target.value })}
            />
            <div
              className="absolute inset-y-0 right-0 top-7 pr-3 flex items-center text-[#845EC2] text-lg cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </div>
            {user.password && (
              <p
                className={`mt-1 text-sm ${
                  passwordStrength === "Excellent"
                    ? "text-green-600"
                    : passwordStrength === "Good"
                    ? "text-yellow-600"
                    : "text-red-600"
                }`}
              >
                Password strength: {passwordStrength}
              </p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-black font-semibold uppercase">
              Re-enter password
            </label>
            <input
              type="password"
              placeholder="Confirm your password"
              className="w-full p-2 border border-gray-300 rounded mt-2"
              value={user.confirmPassword}
              name="confirmPassword"
              onChange={(e) => updateState({ confirmPassword: e.target.value })}
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#bf98ce] text-white p-2 rounded transition-colors cursor-pointer"
          >
            Save Password
          </button>
        </form>

      </div>
    </div>
  );
}
